import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import TextInput from '@/components/ui/text-input';
import { useDatePickerContext } from '../../hooks/use-date-picker-context';
import { dateMask, parseDateFromMask } from '../../utils/date-mask';

export function DateInput() {
  const { value, onChange } = useDatePickerContext();
  const [inputValue, setInputValue] = useState(dayjs(value).format('DD/MM/YYYY'));

  const currentMinutes = dayjs(value).minute();
  const currentHours = dayjs(value).hour();

  // Update input value when external value changes
  useEffect(() => {
    setInputValue(dayjs(value).format('DD/MM/YYYY'));
  }, [value]);

  // Handle input change with date mask
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = dateMask(event.target.value);
    setInputValue(maskedValue);

    // Try to parse the date and update if valid
    if (maskedValue.length === 10) {
      // Complete DD/MM/YYYY format
      const parsedDate = parseDateFromMask(maskedValue, value);
      if (parsedDate !== value) {
        // Preserve the current time when updating the date
        const updatedDate = dayjs(parsedDate)
          .hour(currentHours)
          .minute(currentMinutes)
          .second(0)
          .millisecond(0)
          .toDate();
        onChange(updatedDate);
      }
    }
  };

  return (
    <TextInput
      value={inputValue}
      onChange={handleInputChange}
      placeholder="DD/MM/YYYY"
      containerProps={{
        sx: {
          display: 'flex',
          padding: '10px 14px',
          alignItems: 'center',
          gap: '8px',
          alignSelf: 'stretch',
          borderRadius: '8px',
          border: '1px solid var(--Gray-300, #D0D5DD)',
          background: 'var(--White, #FFF)',
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          height: '45px',
        },
      }}
      sx={{
        '& .MuiInputBase-input': {
          color: 'var(--Gray-900, #101828)',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
          '&::placeholder': {
            color: 'var(--Gray-500, #667085)',
          },
        },
      }}
      inputProps={{
        maxLength: 10,
      }}
    />
  );
}
